import React from 'react';
import styled from 'styled-components';

import {
	TableRow,
	TableHead,
	TableContainer,
	TableCell,
	TableBody,
	Table,
} from '@material-ui/core/';

const Root = styled.div`
	table {
		thead {
			border-bottom: 2px solid
				${(props) => props.theme.palette.blocks.table.thead.borderColor};

			tr {
				th {
					font-weight: bold;
				}
			}
		}

		thead,
		tbody {
			tr {
				th,
				td {
					text-align: right;
				}
			}
		}
	}
`;

const generateRow = (x, i, header) => (
	<TableRow key={`tr-${i}`}>
		{header.map((y, k) => (
			<TableCell key={`trc-${k}`}>{x[y.prop]}</TableCell>
		))}
	</TableRow>
);

export default function TableDefault({ data, header, size }) {
	return (
		<Root>
			<TableContainer>
				<Table aria-label="simple table" size={size}>
					<TableHead>
						<TableRow>
							{header.map((x, i) => (
								<TableCell key={`thc-${i}`}>{x.name}</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>{data.map((x, i) => generateRow(x, i, header))}</TableBody>
				</Table>
			</TableContainer>
		</Root>
	);
}
